// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const SlowLoadComponent = () => {
    const { t } = useTranslation();

    const linkStyle: React.CSSProperties = {
        textDecoration: "none",
        padding: "12px 24px",
        background: "#00345F",
        color: "white",
        fontSize: "16px",
        borderRadius: "8px",
        transition: "background 0.3s"
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px", maxWidth: "500px", margin: "40px auto" }}>

            <img
                src="https://cdn-icons-png.flaticon.com/512/4076/4076432.png"
                alt={`${t('common.slowLoad.imageAlt')}`}
                width="120"
                style={{ opacity: 0.7, marginBottom: "20px"}}
            />

            <h2 style={{ color: "#020202", fontSize: "22px", marginBottom: "10px" }}>
                 {t('common.slowLoad.title')}
            </h2>

            <p style={{ color: "#020202", opacity: 0.7, fontSize: "16px", marginBottom: "20px" }}>
                 {t('common.slowLoad.suggestion')}
            </p>

            <Link
               to="/"
               style={linkStyle}
               title={t('navigation.homeLinkTitle') || 'Home'}
            >
                 {t('common.slowLoad.backToHomeLink')}
            </Link>

        </div>
    )
}

export default SlowLoadComponent;